import React, { useRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import './articleDetails.scss';
import BodyJsonParser from '../parser';
import { Link } from 'react-router-dom';
import { altLtGray, techBlack } from '../../../../common/utils/constant';
import { SectionWrapper } from '../../../../theme/layouts/MainLayout';
import PageNotFound from '../../../404Page';
import AppImage from '../../../../common/features/image';

const AlertComp = () => (
  <div className="msg-container m-4">
    <div className="alert alert-danger" role="alert">
      <strong>Error</strong> Template not configured!
      <Link to="/">Back</Link>
    </div>
  </div>
);

const DetailsHeader = ({ jsonData }) => {

  const containerRef = useRef(null);
  
  if (!jsonData?.body) return <PageNotFound />;

  const {
    body,
    headerSection: {
      eyeBroText,
      headerH1,
      label1,
      label2,
      label3,
      isHeroImageSizeLarge = false,
      heroImageText = '',
      heroImage = '',
    },
  } = jsonData;

  const heroImg = heroImage ?? '/';

  return (
    <>
    <SectionWrapper bg={techBlack}>
      <div className={!isHeroImageSizeLarge ? "article-hero-section" : 'intel-article-section'} >
        <Row ref={containerRef}>
          <Col md={12} sm={12}>
            <div className="hero-title">{eyeBroText}</div>
          </Col>
          <Col md={12} sm={12}>
            <div className="subTitle">{headerH1}</div>
          </Col>
        </Row>
        <Row className='label-gap'>
          {[label1, label2, label3].map((label, index) => (
            <Col md={4} sm={12} key={index}>
              <div className="title">{label}</div>
            </Col>
          ))}
        </Row>
        {!isHeroImageSizeLarge && <div className="img-heading">{heroImageText}</div>}
        {!isHeroImageSizeLarge && 
        (
        <div className='success-test'>
        <div className='success-story-img-container'>
        <AppImage className='success-image' src={heroImg} style = {{ backgroundSize: `${isHeroImageSizeLarge ? 'cover': 'contain' }`}} alt={eyeBroText} title={eyeBroText} /> 
        </div>
        </div> )}
        </div> 
      </SectionWrapper> 
      {isHeroImageSizeLarge && 
      (<div className='intel-global-wrapper' style={{backgroundColor:{altLtGray}}}>
      <div className='intel-main-wrapper'>
      <div className='intel-image-container'>
      <AppImage className="image" src={heroImg} style ={{backgroundSize: `${isHeroImageSizeLarge ? 'cover': 'contain' }` }} alt={eyeBroText} title={eyeBroText} />
      </div> 
      </div>
      </div> )}
      <SectionWrapper bg={altLtGray}>
      <div className={!isHeroImageSizeLarge? "article-hero-section2" : "intel-article-section2"} >
        {Array.isArray(body) &&
          body.map((item, i) => <BodyJsonParser key={`${item.category}-${i}`} category={item.category} data={item} jsondata={jsonData} />)}
      </div>
     
      </SectionWrapper>
    </>
  );
};

export default DetailsHeader;
